import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import './SocialLogin.css';

function SuccessPage() {
	const navigate = useNavigate();
	const location = useLocation();
	const message = location.state?.message || 'Your integration was successful!';

	const nextSteps = [
		'Your trade confirmations will be sent to our email tradeconfirmation@brili.tech.',
		'Your portfolio data will be synchronized automatically.',
		'You can see your updated portfolio in your dashboard.',
	];

	return (
		<div style={{ minHeight: '100vh', background: '#fff' }}>
			<div style={{ maxWidth: 480, margin: '40px auto', padding: 0 }}>
				<div
					className="custom-card"
					style={{ boxSizing: 'border-box', padding: 0 }}
				>
					<div
						className="custom-card-header-row"
						style={{
							justifyContent: 'space-between',
							alignItems: 'center',
							padding: '32px 32px 0 32px',
							display: 'flex',
						}}
					>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<span
								style={{
									color: '#059669',
									fontSize: 32,
									marginRight: 12,
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<svg
									width="36"
									height="36"
									fill="none"
									viewBox="0 0 24 24"
									stroke="#059669"
									strokeWidth="2"
								>
									<circle
										cx="12"
										cy="12"
										r="10"
										stroke="#059669"
										strokeWidth="2"
										fill="#d1fae5"
									/>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										d="M9 12l2 2 4-4"
										stroke="#059669"
										strokeWidth="2"
									/>
								</svg>
							</span>
							<h1
								className="page-title"
								style={{ color: '#059669', fontSize: '1.3rem', margin: 0 }}
							>
								Integration Successful
							</h1>
						</div>
						<img
							src="/brilitech-logo.png"
							alt="logo"
							className="logo-img"
							style={{
								width: 64,
								height: 64,
								objectFit: 'contain',
								borderRadius: 4,
								opacity: 0.9,
								marginLeft: 16,
							}}
						/>
					</div>
					<div style={{ margin: '24px 0 0 0', padding: '0 32px 32px 32px' }}>
						<div
							style={{
								background: '#d1fae5',
								border: '1px solid #a7f3d0',
								color: '#065f46',
								borderRadius: 8,
								padding: '18px 20px',
								marginBottom: 24,
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'flex-start',
								gap: 4,
								flexWrap: 'wrap',
							}}
						>
							<span
								style={{
									fontWeight: 600,
									fontSize: '1.2rem',
									minWidth: 120,
									textAlign: 'left',
								}}
							>
								Success
							</span>
							<span
								style={{ fontSize: '1rem', fontWeight: 400, textAlign: 'left' }}
							>
								{message}
							</span>
						</div>
						<div
							style={{
								background: '#f8fafc',
								borderRadius: 8,
								padding: '20px 20px',
								marginBottom: 32,
							}}
						>
							<div
								style={{ fontWeight: 600, fontSize: '1.1rem', marginBottom: 8 }}
							>
								Next Steps:
							</div>
							<ul
								style={{
									color: '#374151',
									fontSize: '1.05rem',
									marginLeft: 20,
									marginBottom: 0,
									paddingLeft: 0,
								}}
							>
								{nextSteps.map((step, idx) => (
									<li key={idx} style={{ marginBottom: 4 }}>
										{step}
									</li>
								))}
							</ul>
						</div>
						<div
							style={{
								display: 'flex',
								gap: 16,
								justifyContent: 'center',
								marginBottom: 16,
								flexWrap: 'wrap',
							}}
						>
							<button
								className="connect-btn"
								style={{
									background: '#fff',
									color: '#111827',
									border: '1px solid #d1d5db',
									minWidth: 140,
									display: 'inline-flex',
									alignItems: 'center',
									gap: 8,
									justifyContent: 'center',
									fontWeight: 600,
								}}
								onClick={() => navigate('/dashboard')}
							>
								Go to Dashboard
								<span
									style={{
										marginLeft: 8,
										display: 'inline-flex',
										alignItems: 'center',
									}}
								>
									<svg
										width="20"
										height="20"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
										strokeWidth="2"
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											d="M17 8l4 4m0 0l-4 4m4-4H3"
										/>
									</svg>
								</span>
							</button>
						</div>
						<div
							style={{
								textAlign: 'center',
								color: '#6b7280',
								fontSize: '1rem',
								marginTop: 8,
							}}
						>
							Need help? Contact us in WhatsApp for support.
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default SuccessPage;
